var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6726 2.32701C14.9696 1.62407 13.83 1.62407 13.127 2.32701L6.2998 9.15422V11.6998H8.84538L15.6726 4.8726C16.3755 4.16965 16.3755 3.02996 15.6726 2.32701Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7998 5.3998C1.7998 4.40569 2.60569 3.5998 3.5998 3.5998H7.1998C7.69686 3.5998 8.0998 4.00275 8.0998 4.4998C8.0998 4.99686 7.69686 5.3998 7.1998 5.3998H3.5998V14.3998H12.5998V10.7998C12.5998 10.3027 13.0027 9.89981 13.4998 9.89981C13.9969 9.89981 14.3998 10.3027 14.3998 10.7998V14.3998C14.3998 15.3939 13.5939 16.1998 12.5998 16.1998H3.5998C2.60569 16.1998 1.7998 15.3939 1.7998 14.3998V5.3998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.fec106ad4e32d0bb09047a7fb838573a.svg";
export { ForwardRef as ReactComponent };